export const DISPOSABLE_EMAILS = ['duck.com']
